<template>
  <div>
    <p class="mb-4">
      Chọn trạng thái mới cho {{ selectedCount }} yêu cầu đã chọn.
    </p>
    <label class="font-weight-bold">Trạng thái <span class="text-danger">*</span></label>
    <el-select
      v-model="status"
      class="w-100"
      filterable
      clearable
      placeholder="Chọn trạng thái"
    >
      <el-option
        v-for="item in LOGISTICS_STATUSES"
        :key="item"
        :label="item"
        :value="item"
      />
    </el-select>

    <div class="d-flex justify-content-end mt-4">
      <button
        type="button"
        class="btn btn-secondary font-weight-bold mr-2"
        :disabled="submitLoading"
        @click="$emit('close')"
      >
        Đóng
      </button>
      <button
        type="button"
        class="btn btn-primary font-weight-bold"
        :disabled="submitLoading || !status"
        @click="$emit('submit', status)"
      >
        <i v-if="submitLoading" class="fas fa-spinner fa-spin mr-1"></i>
        {{ submitLoading ? "Đang lưu..." : "Cập nhật trạng thái" }}
      </button>
    </div>
  </div>
</template>

<script>
import { LOGISTICS_STATUSES } from "@/core/option/logisticsOption";

export default {
  name: "DialogChangeLogisticsStatus",
  props: {
    selectedCount: {
      type: Number,
      required: true,
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      LOGISTICS_STATUSES,
      status: null,
    };
  },
};
</script>
